export class CommonComponent {
   getString(val: string | undefined) {
      if (val) {
         return val;
      }
      return '';
   }
}
